import React from 'react';
import PropTypes from 'prop-types';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const Datepicker = ({
  id,
  name,
  format,
  label,
  defaultValue,
  onChange,
  sx,
  error,
  readOnly,
}) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DemoContainer components={['DatePicker']}>
      <DatePicker
        id={id}
        name={name}
        format={format}
        label={label}
        defaultValue={defaultValue ? dayjs(defaultValue) : defaultValue}
        onChange={onChange}
        sx={sx}
        disableFuture
        readOnly={readOnly}
        slotProps={{
          textField: {
            error: error !== '',
            helperText: error,
          },
        }}
      />
    </DemoContainer>
  </LocalizationProvider>
);

Datepicker.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  readOnly: PropTypes.bool,
};
Datepicker.defaultProps = {
  format: 'YYYY/MM/DD',
  sx: {},
  defaultValue: null,
  error: '',
  readOnly: false,
};

export default Datepicker;
